import { formatTicketPrice } from "./PriceCalculator";

const BreakdownRow = ({ label, amount, bold = false }) => (
  <div
    className={`flex justify-between gap-4 ${
      bold ? "font-semibold text-primary border-t pt-2 mt-1" : ""
    }`}
  >
    <span>{label}</span>
    <span>{formatTicketPrice(amount)}</span>
  </div>
);

export default function PriceBreakdown({ calc, quantity = 1 }) {
  if (!calc || calc.totalPrice <= 0) return null;

  const q = quantity;

  return (
    <div className="text-sm text-gray-700 space-y-1">
      <BreakdownRow label="Billet" amount={calc.ticketPrice * q} />
      <BreakdownRow label="Frais de service" amount={calc.serviceFee * q} />
      <BreakdownRow label="Sous-total" amount={calc.subtotal * q} bold />
      <BreakdownRow label="TPS (5 %)" amount={calc.tps * q} />
      <BreakdownRow label="TVQ (9,975 %)" amount={calc.tvq * q} />
      <BreakdownRow label="Total payé" amount={calc.totalPrice * q} bold />
    </div>
  );
}
